export const STUDIES_COLUMN_LABELS = {
  title: 'Title',
  state: 'Status',
  style: 'Type',
  updated_at: 'Last updated',
  created_at: 'Created',
  options: '',
  owner_id: 'Owner',
  moderator_ids: 'Moderators',
  creator_id: 'Creator',
  completed: 'Completed',
  team_id: 'Team'
};

export const STATIC_COLUMNS = ['title', 'options'];

export const DISABLED_GROUPED_STUDIES_VIEW_MESSAGE =
  'Grouping isn’t supported when using Pagination. Please disable if you want to use Grouping.';

export const PAGINATED_STUDIES_VIEW_MESSAGE =
  'For improved performance, enable pagination to separate study loading into separate pages.';
